import React, { useState } from 'react';
import './DriverDetail.scss';
import { Row, Col } from 'react-bootstrap';
import TextContent from '../../_common/TextContent';
import { LoadStatusEnum } from '../../../types/LoadStatusEnum';
import SplitLoadModal from '../../SplitLoadModal/SplitLoadModal';
import AssignDriverModal from '../../ListItem/AssignDriver';
import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
import { useStoreContext } from '../../App/StoreProvider';

interface DriverDetailProps {
    driver?: string | null;
    carrier?: string | null;
    box?: string | null;
    truck?: string | null;
    chassis?: string | null;
    status?: string | null;
    loadId?: number;
    lofaId?: number;
    regionId?: number;
    proppantName?: string;
    sandPO?: string;
    driverStatus?: string;
    driverId?: number;
    isSplit?: boolean;
    loadingFacility?: string;
    jobId?: number | null | undefined;
    jobName?: string;
    refetch: () => void;
    secondaryDriverId?: number;
}

const DriverDetail = ({
    driver,
    carrier,
    box,
    truck,
    chassis,
    status,
    loadId,
    lofaId,
    regionId,
    proppantName,
    sandPO,
    driverStatus,
    driverId,
    isSplit,
    loadingFacility,
    jobId,
    jobName,
    refetch,
    secondaryDriverId,
}: DriverDetailProps): React.ReactElement => {
    const [state] = useStoreContext();
    const [showModal, setShowModal] = useState(false);
    const handleOnClickHide = (): void => {
        setShowModal(false);
    };
    const {
        loadList: { filters, searchPhrase },
    } = state;
    const canSplitLoads = useAuthContext().userHasPermission(PermissionEnum.SplitLoads);
    return (
        <Col>
            <Row className="DriverDetail-Title ">Driver Details</Row>
            <Row className='custom-driver-details'>
                <TextContent hasTopMargin title={'Driver: '} value={driver || ''}></TextContent>
                <div onClick={(): void => setShowModal(true)}>
                    {(status === LoadStatusEnum.LOADED || status === LoadStatusEnum.ON_SITE) &&
                        canSplitLoads &&
                        !isSplit && (
                            <Row className='custom-driver-details'>
                                <i className="material-icons DriverDetail-LinkContainer">call_split</i>
                                <p className="DriverDetail-LinkContainer">Split Load</p>
                            </Row>
                        )}
                </div>
                <SplitLoadModal
                    onClickShow={() => setShowModal(true)}
                    show={showModal}
                    onClickHide={handleOnClickHide}
                    loadId={loadId || 0}
                    proppantName={proppantName}
                    sandPO={sandPO}
                    regionId={regionId}
                    lofa={loadingFacility}
                    lofaId={lofaId || 0}
                    jobId={jobId}
                    driverName={driver || ''}
                    loadListfilters={filters}
                    loadListsearchPhrase={searchPhrase}
                    refetch={refetch}
                />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Carrier: '} value={carrier || ''}></TextContent>
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Box: '} value={box || ''}></TextContent>
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Truck: '} value={truck || ''}></TextContent>
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Chassis: '} value={chassis || ''}></TextContent>
            </Row>
            {secondaryDriverId !== driverId && (
                <Row>
                    {driverStatus === 'Accepted' ? (
                        <div className="DriverDetail-StatusLabel">
                            <i className="material-icons complete-icon">check_circle_outline</i>
                            <span className="status-label">Accepted</span>
                        </div>
                    ) : (
                        ''
                    )}
                    {driverStatus === 'Rejected' ? (
                        <div className="DriverDetail-StatusLabel">
                            <i className="material-icons rejected-icon">highlight_off</i>
                            <span className="status-label">Rejected</span>
                        </div>
                    ) : (
                        ''
                    )}
                    {driverStatus === 'Pending' ? (
                        <div className="DriverDetail-StatusLabel">
                            <i className="material-icons pending-icon">restore</i>
                            <span className="status-label">Pending</span>
                        </div>
                    ) : (
                        ''
                    )}
                </Row>
            )}

            {(driverStatus === 'Rejected' && (status == LoadStatusEnum.CREATED || status == LoadStatusEnum.ASSIGNED)) ||
            (driverId === 0 && LoadStatusEnum.CREATED) ? (
                <AssignDriverModal
                    jobId={jobId}
                    proppantName={proppantName || ''}
                    lofa={loadingFacility || ''}
                    regionId={regionId || 0}
                    loadId={loadId || 0}
                    lofaId={lofaId || 0}
                    isFromLoads={true}
                    isSplitLoad={false}
                    sandPO={sandPO}
                    driverName={driver || ''}
                    jobName={jobName || ''}
                    refetch={refetch}
                />
            ) : (
                ''
            )}
        </Col>
    );
};

export default DriverDetail;
